// src/shared/noop.ts
var noop = () => void 0;

export { noop };
//# sourceMappingURL=chunk-SGGNWCK6.mjs.map
//# sourceMappingURL=chunk-SGGNWCK6.mjs.map